module.exports = __webpack_public_path__ + "img/superpower.c68a88ff.jpg";